import styles from "./ErrorMessage.module.css";
import classNames from 'clsx';
export const ErrorMessage = ({ message, className }: any) => {
    return (
        <div className={classNames(styles.error_message, className)}>{message}</div>

    )
}